module.exports = function getResource(label) {
    const resources = {
        popularNow: 'EN VEDETTE MAINTENANT!',
        popular: 'POPULAR!',
        peopleViewed: 'd’autres personnes ont récemment consulté cet article.',
        recentViews: 'consultations récentes.'
    };

    return resources[label];
};
